import React from 'react';
import { useDispatch } from 'react-redux';
import { Tooltip, Icon, Button } from 'antd';
import cn from 'classnames';
import { requestListActions } from '../../request-list.actions';
import { actions as newRequestActions } from '../../../CreateRequest/new-request.actions';
import styles from './ActionsCell.module.scss';

const ActionsCell = ({ request }) => {
  const dispatch = useDispatch();

  const handleFavoritesBtnClick = (e) => {
    e.stopPropagation();
    dispatch(requestListActions.setRequestFavorite(request));
  };

  const handleCreateRequestBtnClick = (e) => {
    e.stopPropagation();

    dispatch(newRequestActions.applyAddrStreet(request.streetId));
    dispatch(
      newRequestActions.applyAddrBuilding(
        request.houseId,
        request.parentServiceId
      )
    );
    dispatch(newRequestActions.setAddrFlatValue(request.addressId));
    dispatch(newRequestActions.setSubserviceValue(request.serviceId));
    dispatch(newRequestActions.applyService(request.parentServiceId));
    dispatch(newRequestActions.applyPossWarranty(request.garantyId > 0));
    dispatch(
      newRequestActions.setWorkerValue(request.master && request.master.id)
    );
    dispatch(
      newRequestActions.setExecuterValue(
        request.executer && request.executer.id
      )
    );
    dispatch(
      newRequestActions.setOwnerData(
        request.clientName,
        request.contactPhones?.substring(1)
      )
    );

    dispatch(newRequestActions.applyAddrServiceCompany(request.companyId));

    dispatch(newRequestActions.openNewRequestModal(request));
  };

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={cn({ 'dspx-ref-show': !request.favorites })}>
          <Tooltip
            title="Избранные"
            placement="left"
          >
            <Button
              ghost
              shape="circle"
              onClick={handleFavoritesBtnClick}
              className={cn(styles.actionBtn, styles.medium, {
                [styles.actionDefault]: !request.favorites,
                [styles.actionActive]: request.favorites,
              })}
            >
              <Icon
                type="crown"
                theme={request.favorites ? 'filled' : 'outlined'}
              />
            </Button>
          </Tooltip>
        </div>
        <div className="dspx-ref-show">
          <Tooltip
            title="Создать заявку"
            placement="left"
          >
            <Button
              ghost
              shape="circle"
              className={cn(
                styles.actionBtn,
                styles.actionDefault,
                styles.medium
              )}
              onClick={handleCreateRequestBtnClick}
              icon="copy"
            />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default ActionsCell;
